import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const UserShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    아이러빗 사용자 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    아이러빗 사용자 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="로그인 Id" value={record?.loginId} />
                        <FieldItem label="이름" value={record?.nickName} />
                        {/* 원본이 raw 값을 그대로 노출했으므로 매핑 없이 유지 */}
                        <FieldItem label="권한" value={record?.auth} />
                        <FieldItem label="전화번호" value={record?.phoneNumber} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
